// In px
export const mobileWidth = 480
export const tabletWidth = 768
export const desktopWidth = 1024
export const largeDesktopWidth = 1200

export function isMobile() {
  if (typeof window === "undefined") return false
  return window.innerWidth <= mobileWidth
}

export function isSmallLaptopAndBelow() {
  if (typeof window === "undefined") return false
  return window.innerWidth <= desktopWidth
}

export function isTabletAndBelow() {
  if (typeof window === "undefined") return false
  return window.innerWidth <= tabletWidth
}

export function isTabletAndAbove() {
  if (typeof window === "undefined") return true
  return window.innerWidth > mobileWidth
}

export function isPortrait() {
  if (typeof window === "undefined") return false
  return window.innerHeight > window.innerWidth
}

export function isLandscape() {
  if (typeof window === "undefined") return true
  return window.innerHeight < window.innerWidth
}
